"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
exports.getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var palette = theme.palette;
    return ({
        root: [
            'ms-Pivot',
            Styling_1.normalize,
            {
                fontSize: Styling_1.FontSizes.medium,
                fontWeight: Styling_1.FontWeights.regular,
                position: 'relative',
                color: palette.themePrimary,
                whiteSpace: 'nowrap',
            },
            className
        ],
        links: [
            'ms-Pivot-links',
            {}
        ],
        link: [
            'ms-Pivot-link',
            {}
        ],
        text: [
            'ms-Pivot-text',
            {}
        ],
        count: [
            'ms-Pivot-count',
            {}
        ],
        icon: [
            'ms-Pivot-icon',
            {}
        ],
        ellipsis: [
            'ms-Pivot-ellipsis',
            {}
        ],
    });
};
//# sourceMappingURL=Pivot.styles.js.map